import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, Form, change } from 'redux-form';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';

class LookupForm extends PureComponent {
    submit = (values) => {
        const hasOwnProperty = Object.prototype.hasOwnProperty;
        function isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== 'object') return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }
            return true;
        }

        var productURL = ( !!values.productURL ) ? values.productURL.trim() : '';
        if( isEmpty( values ) ) {
            //no input
            throw new SubmissionError( { productURL: 'URL required' } );
        } else if( productURL === '' ) {
            throw new SubmissionError({ productURL: 'URL required' });
        }

        this.props.nextStep( { url: productURL } );
        this.props.reset();
    }
    render() {
        const { handleSubmit, pristine, submitting } = this.props;
        return (
            <Form className={ style.addProductForm } onSubmit={ handleSubmit( this.submit ) }>
                <p>2 ways to add:</p>
                <Field
                id='productURL'
                name='productURL'
                label='Paste a Product Link'
                component={ FormTextField }
                className={ style.formItem }
                fullWidth
                autoFocus />
                <p className={ style.or }>or</p>
                <p style={ { marginTop: '10px' } }>Download <a href='https://chrome.google.com/webstore/detail/desirelist/cmifjccfhaadddocjkojgfhafleeafcm' target='_blank'
                rel='noopener noreferrer'>DesireList browser button</a> to add from anywhere on the web</p>
                <div className={ style.submitButton }>
                    <PrimaryButton
                    label="Lookup Product"
                    disabled={ pristine || submitting }
                    fullWidth
                    type="submit" />
                </div>
            </Form>
        );
    }
}
LookupForm.defaultProps = {
    nextStep: ()=>{},
};

LookupForm = reduxForm( {
    form: 'LookupForm',
} )( LookupForm );

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'LookupForm', field, value ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( LookupForm );
